if (!window.melandiSizePickerInstalled) {
  window.melandiSizePickerInstalled = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.melandi-size-button');
    if (button) {
      const group = button.closest('[data-size-select]');
      const select = document.getElementById(group.dataset.sizeSelect);
      if (select) {
        select.value = button.dataset.sizeValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    const opener = event.target.closest('.melandi-size-chart-open');
    if (opener) document.getElementById(opener.dataset.dialogId)?.showModal();
    const close = event.target.closest('.melandi-size-chart-close');
    if (close) close.closest('dialog').close();
    if (event.target.matches('.melandi-size-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLSelectElement)) return;
    document.querySelectorAll('[data-size-select]').forEach((group) => {
      if (group.dataset.sizeSelect !== event.target.id) return;
      group.querySelectorAll('.melandi-size-button').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.sizeValue === event.target.value)));
    });
  });
}
